module.exports = __webpack_public_path__ + "img/instagram.80a2c4c9.svg";